import React from "react";
import { BsX } from "react-icons/bs";
import { FiFileText, FiImage, FiLink, FiVideo, FiMic } from "react-icons/fi";
import "./chat-reply.css";

const NATURE_ICONS = {
  texte: null,
  fichier: <FiFileText size={14} />,
  lien: <FiLink size={14} />,
  code_meeting: <FiVideo size={14} />,
  messageVocal: <FiMic size={14} />,
  annoncePrivé: <FiFileText size={14} />,
  annoncePublic: <FiFileText size={14} />,
};

const NATURE_LABELS = {
  texte: "",
  fichier: "Fichier",
  lien: "Lien",
  code_meeting: "Réunion",
  messageVocal: "Message vocal",
  annoncePrivé: "Annonce",
  annoncePublic: "Annonce",
};

export default function ReplyPreview({ replyTo, onClear }) {
  if (!replyTo) return null;

  const senderName = replyTo.replyToSender?.displayName || "Vous";
  const preview = replyTo.replyToContenu || "";
  const nature = replyTo.replyToNature;
  const icon = NATURE_ICONS[nature];
  const label = NATURE_LABELS[nature];

  return (
    <div className="chat-reply-preview">
      <div className="chat-reply-preview-accent" />
      <div className="chat-reply-preview-body">
        <div className="chat-reply-preview-header">
          <span className="chat-reply-preview-author">{senderName}</span>
          <button className="chat-reply-preview-close" onClick={onClear}>
            <BsX size={20} />
          </button>
        </div>
        <div className="chat-reply-preview-content">
          {icon && <span className="chat-reply-preview-icon">{icon}</span>}
          {label && !preview && (
            <span className="chat-reply-preview-label">{label}</span>
          )}
          {preview && (
            <span className="chat-reply-preview-text">
              {preview.length > 100 ? preview.slice(0, 100) + "..." : preview}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
